import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'antera-lib-kanban-header',
  templateUrl: './kanban-header.component.html',
  styleUrls: ['./kanban-header.component.scss'],
})
export class KanbanHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
